import { combineReducers } from "redux";
import _ from "lodash";
import auth from "./modules/auth/Auth.ducks.js";
import kids from "./modules/kids/Kids.ducks.js";
import life from "./modules/kids/kids-list/creche-life/Life.ducks";
import gestionCreche from "./modules/kids/kids-list/creche/gestionCreche.ducks";
import modals from "./modules/kids/kids-list/modals/Modals.ducks";
import ficheEnfant from "./modules/kids/kids-list/fiche-enfant/FicheEnfant.ducks";
import compte from "./components/compte/compte.ducks";
import Evenements from "./modules/kids/kids-list/evenements/Evenements.ducks";
import Communaute from "./modules/kids/kids-list/communaute/Communaute.duck";
import staff from "./modules/kids/kids-list/staff/Staff.ducks";
import Menus from "./modules/kids/kids-list/menus/Menus.ducks";
import {
  UPDATE_AGENT_FULFILLED,
  UPDATE_AGENT_REJECTED,
  UPDATE_PASSWORD_FULFILLED,
  UPDATE_PASSWORD_REJECTED,
} from "./components/compte/compte.ducks";
import {
  POST_ABSENCE_FULFILLED,
  POST_ABSENCE_REJECTED,
  DELETE_ABSENCE_FULFILLED,
  DELETE_ABSENCE_REJECTED,
  PUT_ABSENCE_FULFILLED,
  PUT_ABSENCE_REJECTED,
} from "./modules/kids/kids-list/modals/modal-enfant/les-tabs-ducks/Absence.ducks";
import {
  POST_ACTIVITE_FULFILLED,
  POST_ACTIVITE_REJECTED,
  DELETE_ACTIVITE_FULFILLED,
  DELETE_ACTIVITE_REJECTED,
  PUT_ACTIVITE_FULFILLED,
  PUT_ACTIVITE_REJECTED,
} from "./modules/kids/kids-list/modals/modal-enfant/les-tabs-ducks/Activite.ducks";
import {
  POST_ARRIVE_FULFILLED,
  POST_ARRIVE_REJECTED,
  DELETE_ARRIVE_FULFILLED,
  DELETE_ARRIVE_REJECTED,
  PUT_ARRIVE_FULFILLED,
  PUT_ARRIVE_REJECTED,
} from "./modules/kids/kids-list/modals/modal-enfant/les-tabs-ducks/Arrive.ducks";
import {
  POST_DEPART_FULFILLED,
  POST_DEPART_REJECTED,
  DELETE_DEPART_FULFILLED,
  DELETE_DEPART_REJECTED,
  PUT_DEPART_FULFILLED,
  PUT_DEPART_REJECTED,
} from "./modules/kids/kids-list/modals/modal-enfant/les-tabs-ducks/Depart.ducks";
import {
  POST_MESSAGE_FULFILLED,
  POST_MESSAGE_REJECTED,
} from "./modules/kids/kids-list/modals/modal-enfant/les-tabs-ducks/Message.ducks";
import {
  POST_PETITCOIN_FULFILLED,
  POST_PETITCOIN_REJECTED,
  DELETE_PETITCOIN_FULFILLED,
  DELETE_PETITCOIN_REJECTED,
  PUT_PETITCOIN_FULFILLED,
  PUT_PETITCOIN_REJECTED,
} from "./modules/kids/kids-list/modals/modal-enfant/les-tabs-ducks/Petitcoin.ducks";
import {
  POST_REPAS_FULFILLED,
  POST_REPAS_REJECTED,
  DELETE_REPAS_FULFILLED,
  DELETE_REPAS_REJECTED,
  PUT_REPAS_FULFILLED,
  PUT_REPAS_REJECTED,
} from "./modules/kids/kids-list/modals/modal-enfant/les-tabs-ducks/Repas.ducks";
import {
  POST_SANTE_FULFILLED,
  POST_SANTE_REJECTED,
  DELETE_SANTE_FULFILLED,
  DELETE_SANTE_REJECTED,
  PUT_SANTE_FULFILLED,
  PUT_SANTE_REJECTED,
} from "./modules/kids/kids-list/modals/modal-enfant/les-tabs-ducks/Sante.ducks";
import {
  POST_SIESTE_FULFILLED,
  POST_SIESTE_REJECTED,
  DELETE_SIESTE_FULFILLED,
  DELETE_SIESTE_REJECTED,
  PUT_SIESTE_FULFILLED,
  PUT_SIESTE_REJECTED,
} from "./modules/kids/kids-list/modals/modal-enfant/les-tabs-ducks/Sieste.ducks";
import {
  ARCHIVE_ENFANT_REJECTED,
  DELETE_ENFANT_REJECTED,
  ARCHIVE_ENFANT_FULFILLED,
  DELETE_ENFANT_FULFILLED,
  UPDATE_IDENTITE_INFO_ENFANT_REJECTED,
  UPDATE_IDENTITE_INFO_PARENT_REJECTED,
  UPDATE_IDENTITE_INFO_TIERCE_REJECTED,
  UPDATE_IDENTITE_INFO_ENFANT_FULFILLED,
  UPDATE_IDENTITE_INFO_PARENT_FULFILLED,
  UPDATE_IDENTITE_INFO_TIERCE_FULFILLED,
} from "../src/modules/kids/kids-list/fiche-enfant/les-tabs-ducks/Identite.ducks";
import {
  GET_EVENT_REJECTED,
  GET_EVENT_FULFILLED,
  ADD_EVENT_REJECTED,
  ADD_EVENT_FULFILLED,
  DELETE_EVENT_REJECTED,
  DELETE_EVENT_FULFILLED,
  EDIT_EVENT_REJECTED,
  EDIT_EVENT_FULFILLED,
} from "./modules/kids/kids-list/evenements/Evenements.ducks";
import {
  POST_ADD_ENFANT_FULFILLED,
  POST_ADD_ENFANT_REJECTED,
} from "./modules/kids/kids-list/creche/creche.ducks";
import {
  ADD_POST_REJECTED,
  ADD_POST_FULFILLED,
  GET_POST_REJECTED,
  GET_POST_FULFILLED,
} from "./modules/kids/kids-list/communaute/Communaute.duck";
import {
  ADD_FERMETURES_REJECTED,
  ADD_FERMETURES_FULFILLED,
  DELETE_FERMETURES_REJECTED,
  DELETE_FERMETURES_FULFILLED,
} from "./modules/kids/kids-list/creche/planningCreche.ducks";
import {
  ADD_SECTION_REJECTED,
  ADD_SECTION_FULFILLED,
  UPDATE_SECTION_REJECTED,
  UPDATE_SECTION_FULFILLED,
  DELETE_SECTION_REJECTED,
  DELETE_SECTION_FULFILLED,
} from "./modules/kids/kids-list/creche/sections.ducks";
import {
  POST_NOTE_FULFILLED,
  POST_NOTE_REJECTED,
  PUT_NOTE_FULFILLED,
  PUT_NOTE_REJECTED,
  DELETE_NOTE_FULFILLED,
  DELETE_NOTE_REJECTED,
} from "./modules/kids/kids-list/fiche-enfant/les-tabs-ducks/Notes.ducks";

export const CLOSE_SNACKBAR_SUCCESS = "CLOSE_SNACKBAR_SUCCESS";
export const CLOSE_SNACKBAR_ERROR = "CLOSE_SNACKBAR_ERROR";

export const OPEN_SNACKBAR_SUCCESS = "OPEN_SNACKBAR_SUCCESS";
export const OPEN_SNACKBAR_ERROR = "OPEN_SNACKBAR_ERROR";

//Action creators pour fermer les alerts d'erreurs/succés
export const closeSnackBar = (name) => {
  if (name === "successMsg") {
    return { type: CLOSE_SNACKBAR_SUCCESS };
  } else {
    return { type: CLOSE_SNACKBAR_ERROR };
  }
};

export const openSnackBar = (name, payload) => {
  if (name === "successMsg") {
    return { type: OPEN_SNACKBAR_SUCCESS, payload: payload };
  } else {
    return { type: OPEN_SNACKBAR_ERROR, payload: payload };
  }
};

//Reducers
let INIT_STATE_succ = {
  message: "Opération accomplie avec succès",
  status: false,
};
let INIT_STATE_err = {
  message: "Il y a eu une Erreur !",
  status: false,
};
const errorMsg = (state = INIT_STATE_err, { type, payload }) => {
  switch (type) {
    case POST_ABSENCE_REJECTED:
    case POST_ACTIVITE_REJECTED:
    case POST_ARRIVE_REJECTED:
    case POST_DEPART_REJECTED:
    case POST_MESSAGE_REJECTED:
    case POST_PETITCOIN_REJECTED:
    case POST_REPAS_REJECTED:
    case POST_SANTE_REJECTED:
    case POST_SIESTE_REJECTED:
    case DELETE_ACTIVITE_REJECTED:
    case DELETE_ABSENCE_REJECTED:
    case DELETE_ARRIVE_REJECTED:
    case DELETE_DEPART_REJECTED:
    case DELETE_PETITCOIN_REJECTED:
    case DELETE_REPAS_REJECTED:
    case DELETE_SANTE_REJECTED:
    case DELETE_SIESTE_REJECTED:
    case PUT_ACTIVITE_REJECTED:
    case PUT_ABSENCE_REJECTED:
    case PUT_ARRIVE_REJECTED:
    case PUT_DEPART_REJECTED:
    case PUT_PETITCOIN_REJECTED:
    case PUT_REPAS_REJECTED:
    case PUT_SANTE_REJECTED:
    case PUT_SIESTE_REJECTED:
    case ARCHIVE_ENFANT_REJECTED:
    case DELETE_ENFANT_REJECTED:
    case UPDATE_AGENT_REJECTED:
    case UPDATE_PASSWORD_REJECTED:
    case GET_EVENT_REJECTED:
    case UPDATE_IDENTITE_INFO_ENFANT_REJECTED:
    case UPDATE_IDENTITE_INFO_PARENT_REJECTED:
    case UPDATE_IDENTITE_INFO_TIERCE_REJECTED:
    case POST_ADD_ENFANT_REJECTED:
    case ADD_POST_REJECTED:
    case GET_POST_REJECTED:
    case ADD_EVENT_REJECTED:
    case DELETE_EVENT_REJECTED:
    case EDIT_EVENT_REJECTED:
    case OPEN_SNACKBAR_ERROR:
    case ADD_SECTION_REJECTED:
    case UPDATE_SECTION_REJECTED:
    case DELETE_SECTION_REJECTED:
    case ADD_FERMETURES_REJECTED:
    case DELETE_FERMETURES_REJECTED:
    case POST_NOTE_REJECTED:
    case PUT_NOTE_REJECTED:
    case DELETE_NOTE_REJECTED:
      return Object.assign({}, state, {
        status: true,
        message: payload && _.isString(payload) ? payload : state.message,
      });
    case CLOSE_SNACKBAR_ERROR:
      return Object.assign({}, state, { status: false });
    default:
      return state;
  }
};

const successMsg = (state = INIT_STATE_succ, { type, payload }) => {
  switch (type) {
    case POST_ABSENCE_FULFILLED:
    case POST_ACTIVITE_FULFILLED:
    case POST_ARRIVE_FULFILLED:
    case POST_DEPART_FULFILLED:
    case POST_MESSAGE_FULFILLED:
    case POST_PETITCOIN_FULFILLED:
    case POST_REPAS_FULFILLED:
    case POST_SANTE_FULFILLED:
    case POST_SIESTE_FULFILLED:
    case DELETE_ACTIVITE_FULFILLED:
    case DELETE_ABSENCE_FULFILLED:
    case DELETE_ARRIVE_FULFILLED:
    case DELETE_DEPART_FULFILLED:
    case DELETE_PETITCOIN_FULFILLED:
    case DELETE_REPAS_FULFILLED:
    case DELETE_SANTE_FULFILLED:
    case DELETE_SIESTE_FULFILLED:
    case PUT_ACTIVITE_FULFILLED:
    case PUT_ABSENCE_FULFILLED:
    case PUT_ARRIVE_FULFILLED:
    case PUT_DEPART_FULFILLED:
    case PUT_PETITCOIN_FULFILLED:
    case PUT_REPAS_FULFILLED:
    case PUT_SANTE_FULFILLED:
    case PUT_SIESTE_FULFILLED:
    case ARCHIVE_ENFANT_FULFILLED:
    case DELETE_ENFANT_FULFILLED:
    case UPDATE_AGENT_FULFILLED:
    case UPDATE_PASSWORD_FULFILLED:
    case GET_EVENT_FULFILLED:
    case UPDATE_IDENTITE_INFO_ENFANT_FULFILLED:
    case UPDATE_IDENTITE_INFO_PARENT_FULFILLED:
    case UPDATE_IDENTITE_INFO_TIERCE_FULFILLED:
    case POST_ADD_ENFANT_FULFILLED:
    case ADD_POST_FULFILLED:
    case ADD_EVENT_FULFILLED:
    case DELETE_EVENT_FULFILLED:
    case EDIT_EVENT_FULFILLED:
    case OPEN_SNACKBAR_SUCCESS:
    case ADD_SECTION_FULFILLED:
    case UPDATE_SECTION_FULFILLED:
    case DELETE_SECTION_FULFILLED:
    case ADD_FERMETURES_FULFILLED:
    case DELETE_FERMETURES_FULFILLED:
    case POST_NOTE_FULFILLED:
    case PUT_NOTE_FULFILLED:
    case DELETE_NOTE_FULFILLED:
      return Object.assign({}, state, {
        status: true,
        message: "Opération accomplie avec succès",
      });
    case CLOSE_SNACKBAR_SUCCESS:
      return Object.assign({}, state, { status: false });
    default:
      return state;
  }
};

const appReducer = combineReducers({
  Menus,
  compte,
  auth,
  kids,
  life,
  modals,
  ficheEnfant,
  successMsg,
  errorMsg,
  Evenements,
  Communaute,
  staff,
  gestionCreche,
});

export default appReducer;
